
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import DemolitionHero from "@/components/demolition/DemolitionHero";
import DemolitionServices from "@/components/demolition/DemolitionServices";
import DemolitionProcess from "@/components/demolition/DemolitionProcess";
import DemolitionSEOContent from "@/components/demolition/DemolitionSEOContent";

const Demolition = () => {
  // Données des départements pour les données structurées
  const departements = [{
    code: "12",
    name: "Aveyron",
    cities: ["Rodez", "Millau", "Villefranche-de-Rouergue", "Decazeville"]
  }, {
    code: "93",
    name: "Seine-Saint-Denis",
    cities: ["Saint-Denis", "Montreuil", "Aubervilliers", "Bobigny"]
  }, {
    code: "11",
    name: "Aude",
    cities: ["Carcassonne", "Narbonne", "Castelnaudary", "Limoux"]
  }, {
    code: "31",
    name: "Haute-Garonne",
    cities: ["Toulouse", "Muret", "Saint-Gaudens", "Colomiers"]
  }, {
    code: "34",
    name: "Hérault",
    cities: ["Montpellier", "Béziers", "Sète", "Agde"]
  }, {
    code: "81",
    name: "Tarn",
    cities: ["Albi", "Castres", "Mazamet", "Gaillac"]
  }, {
    code: "46",
    name: "Lot",
    cities: ["Cahors", "Figeac", "Gourdon", "Souillac"]
  }, {
    code: "48",
    name: "Lozère",
    cities: ["Mende", "Marvejols", "Florac", "Saint-Chély-d'Apcher"]
  }, {
    code: "15",
    name: "Cantal",
    cities: ["Aurillac", "Saint-Flour", "Mauriac", "Murat"]
  }, {
    code: "75",
    name: "Paris",
    cities: ["Paris 1er", "Paris 2e", "Paris 3e", "Paris 4e"]
  }, {
    code: "92",
    name: "Hauts-de-Seine",
    cities: ["Nanterre", "Boulogne-Billancourt", "Courbevoie", "Rueil-Malmaison"]
  }, {
    code: "94",
    name: "Val-de-Marne",
    cities: ["Créteil", "Vitry-sur-Seine", "Champigny-sur-Marne", "Saint-Maur"]
  }, {
    code: "95",
    name: "Val-d'Oise",
    cities: ["Cergy", "Argenteuil", "Sarcelles", "Franconville"]
  }, {
    code: "77",
    name: "Seine-et-Marne",
    cities: ["Meaux", "Melun", "Chelles", "Pontault-Combault"]
  }, {
    code: "78",
    name: "Yvelines",
    cities: ["Versailles", "Saint-Germain-en-Laye", "Sartrouville", "Poissy"]
  }, {
    code: "91",
    name: "Essonne",
    cities: ["Évry", "Corbeil-Essonnes", "Massy", "Savigny-sur-Orge"]
  }];

  // Services spécialisés pour les données structurées
  const servicesSpecialises = [
    {
      title: "Démolition totale",
      description: "Destruction complète de bâtiments avec récupération de matériaux"
    },
    {
      title: "Démolition partielle",
      description: "Interventions ciblées pour rénovation et aménagement"
    },
    {
      title: "Déconstruction sélective",
      description: "Démontage méthodique pour valorisation maximale"
    },
    {
      title: "Désamiantage",
      description: "Retrait sécurisé des matériaux amiantés"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Services de Démolition Professionnels - Groupe Fabre Environnement" 
        description="Expert en démolition et déconstruction dans toute la France. Démolition totale, partielle, désamiantage. Intervention rapide, respect environnemental. Devis gratuit." 
        canonical="/nos-services/demolition"
        keywords="démolition, déconstruction, désamiantage, démolition bâtiment, entreprise démolition, démolition Paris, démolition Toulouse, démolition Aveyron"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Services de Démolition",
          "description": "Services professionnels de démolition et déconstruction respectueux de l'environnement",
          "provider": {
            "@type": "Organization",
            "name": "Groupe Fabre Environnement",
            "url": "https://www.groupefabre-environnement.fr"
          },
          "areaServed": departements.map(dept => ({
            "@type": "AdministrativeArea",
            "name": dept.name
          })),
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Services de démolition",
            "itemListElement": servicesSpecialises.map((service, index) => ({
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": service.title,
                "description": service.description
              }
            }))
          }
        }}
      />
      <Navbar />
      
      <main className="flex-1">
        <DemolitionHero />
        <DemolitionServices />
        <div className="container mx-auto px-4">
          <DemolitionProcess />
          <DemolitionSEOContent />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Demolition;
